<template>
  <CheckboxRow
    class="clr-white"
    style="--row-wrap: nowrap; --clr-row-back: var(--clr-black-2)"
    :item="resultView"
    :isSingle="true"
    :hasAny="false"
    @update="item => handleUpdate(item)"
  >
    <template #default="v">
      <!-- {{ item.getName(v.id) }} -->
      {{ $t(`trainer.${v.id}`) }}
    </template>
  </CheckboxRow>
</template>

<script>
import CheckboxRow from '@/components/Forms/CheckboxRow'
import { allSwitchers } from '@/store/switchers/switchers'

export default {
  name: 'TrainerResultChartSwitcherV2',
  components: {
    CheckboxRow,
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    handleUpdate(item) {
      this.$store.dispatch(`switchers_set_item`, {
        key: 'sw_trainer_result_chart',
        item: { payload: item.selected[0] },
      })
    },
  },
  computed: {
    resultView() {
      const options = allSwitchers().sw_trainer_result_chart.map(i => i.payload)
      const selected = [this.$store.getters.sw_trainer_result_chart]
      const res = {
        id: 'trainer_result_view',
        title: this.$t('trainer.trainer_result_view'),
        options,
        selected,
      }
      return res
    },
  },
}
</script>
